import CollectionDataGrid from '@/components/CollectionDataGrid'
import { expandToUUID } from '@/utils'
import { useMemo } from 'react'

const columns = [
  { field: 'code', headerName: 'Короткий код', width: 150 },
  { field: 'uuid', headerName: 'UUID', width: 300 },
  { field: 'rfid', headerName: 'RFID', width: 300 },

  { field: 'manufacturerName', headerName: 'Производитель', width: 300 },
  { field: 'productName', headerName: 'Продукт', width: 300 },
  { field: 'numberInSeries', headerName: 'Номер в серии', width: 130 },
  { field: 'count', headerName: 'Количество', width: 100 },
  { field: 'first', headerName: 'Первый', width: 100 },
  { field: 'last', headerName: 'Последний', width: 100 },
]

export default function RfidsTable({ rfids, series, loading, ...rest }) {

  const rfidsAsCollection = useMemo(() => !rfids ? [] : rfids.map(([seriesId, numberInSeries, rfid]) => ({
    ...series[seriesId],
    id: rfid,
    rfid,
    uuid: expandToUUID(rfid),
    code: expandToSeriesCode(rfid),
    numberInSeries,
  })))

  return <>
    <CollectionDataGrid
      collection={rfidsAsCollection}
      columns={columns}
      loading={loading}
      {...rest}
    />
  </>

}

const expandToSeriesCode = text => {
  return `${text.slice(0, 3)}-${text.slice(3, 6)}-${text.slice(6, 12)}`
}